import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'

import { AppRoutes } from '@/constants/appRoutes'
import { EUserStatus } from '@/constants/userStatus'
import { useAppDispatch } from '@/hooks/redux'
import { catchWithSentry } from '@/hooks/useCatchWithSentry'
import { api } from '@/store/api'
import { useLoginMutation } from '@/store/api/Auth/Auth.query'
import { setSession } from '@/store/api/Auth/Auth.slice'
import { identifyUser } from '@/utils/analytics/analytics'
import { AuthMethods } from '@/utils/analytics/analyticsConstants'

export const useLogin = () => {
  const { t } = useTranslation()

  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const [loginRequest, { isLoading }] = useLoginMutation()

  const login = async (password: string, email: string) => {
    try {
      dispatch(api.util.resetApiState())

      const response = await loginRequest({
        email,
        password,
      }).unwrap()

      dispatch(setSession(response.info))

      identifyUser(email, {
        email: email,
        user_status: response.info.userStatus,
        method: AuthMethods.EMAIL,
      })

      if (response.info.userStatus === EUserStatus.ACTIVE) {
        navigate(AppRoutes.dashboard)
      } else if (
        response.info.userStatus === EUserStatus.PENDING_EMAIL_VERIFICATION
      ) {
        navigate(AppRoutes.registerEmailVerification)
      } else if (response.info.userStatus === EUserStatus.PENDING_MOTIVATION) {
        navigate(AppRoutes.welcomeToSelfCheck)
      } else if (
        response.info.userStatus === EUserStatus.PENDING_SET_PERSONAL_INFO
      ) {
        navigate(AppRoutes.personalInfo)
      } else if (
        response.info.userStatus === EUserStatus.PENDING_SOCIAL_MEDIAS
      ) {
        navigate(AppRoutes.setupDigitalFootprint)
      } else if (
        response.info.userStatus === EUserStatus.PENDING_ACCOUNT_ACTIVATION
      ) {
        navigate(AppRoutes.defaultBehaviorAndTopics)
      }
    } catch (e) {
      catchWithSentry(e)
      toast.error(t('feedback.toast.invalidCredentials'))
    }
  }
  return { login, isLoading }
}
